import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleHeader
} from '../../../components/Collapsible';
import DataTable from '../../../components/DataTable';
import DescriptionBox from '../../../components/DescriptionBox';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setCollapseContentTracking,
  addLead
} from '../../../store/actions/dataLayer';
import {
  getTitle,
  getDetailsData,
  getBoatDetails,
  getPropulsionData,
  getMeasurementsData,
  getFeaturesData,
  formatMoreDetailsDescriptions,
  isFSBOContact,
  getBrokerSpotlightInfo,
  showPriceCalculation
} from '../../../utils/listingHelper';
import {
  getCurrentLocale,
  getCurrentBoats as bts
} from '../../../utils/language';
import BrokerSpotlight from '../BrokerSpotlight';
import { injectIntl } from 'react-intl';
import messages from '../../../utils/translationMessages';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import {
  BREAKPOINTS,
  isManufacturerListing
} from '../../../utils/commonHelper';
import { CTA_APPLY_NOW_CALCULATOR_BDP } from '../../../constants/BoatLoans';
import BoatLoans from '../BoatLoans';
import ContactGroup from '../ContactGroup';
import ServicesByDFP from '../ServicesByDFP';
import DealerOtherProducts from '../DealerOtherProducts';
import { Ad } from '@dmm/react-common-components';
import { PortalConfigContext } from '../../../config/portal';
import { BrokerSpotlightCard } from '@dmm/lib-react-broker-card';
import { YoutubeVideos } from '@dmm/lib-react-videos';
import '@dmm/lib-react-videos/dist/@dmm/lib-react-videos.min.css';
import { setProductImpression } from '../../../store/actions/dataLayer';
import '@dmm/lib-react-broker-card/dist/@dmm/lib-react-broker-card.min.css';
import { PRODUCT_CATEGORY } from '../../../constants/dataLayer';
import PaymentCalculator from '../../../components/PaymentCalculator';
import ConversationalCta from '../../../components/ConversationalCta';
import { BoatDetails } from '@dmm/lib-react-ui-components';
import { isBrokerBDP } from '../../../utils/newBDPHelper';

const DetailsSectionVariant1 = (props) => {
  const N_A = 'n/a';
  let brokerSpotlightInfo = null;
  const context = useContext(PortalConfigContext);

  useEffect(() => {
    const { listing } = props;
    const brokerSpotlightFeature = get(
      context,
      'pages.details.brokerSpotlight'
    );

    if (brokerSpotlightFeature && listing.owner?.brokerSpotlightId) {
      props.setProductImpression(
        listing.owner.brokerSpotlightId,
        bts().LISTING_PREMIUM_BROKER,
        N_A,
        N_A,
        PRODUCT_CATEGORY.PREMIUM_BROKER,
        undefined,
        undefined,
        listing.model,
        `${listing.year} ${listing.make} ${listing.model}`,
        listing.make
      );
    }
  }, []);

  const {
    breakpoint,
    listing,
    isLoading,
    showManufacturerForm,
    customUom,
    setCollapseContentTracking,
    onOpenContactForm,
    intl: { formatMessage: t },
    adParams,
    openBoatLoansSection,
    openBoatLoansCounter,
    boatLoansSection,
    openPaymentSection,
    openPaymentCounter,
    tridentLoanAmount,
    tridentTeaserRate,
    tridentTermInMonths,
    showModalPreQualified,
    isLeadSubmitted
  } = props;
  let paymentCalculatorOpenState =
    openPaymentSection !== 'payment-calculator' ? 'close' : 'open';

  const portal = get(context, 'name');
  const title = getTitle(listing);
  const dealerListings = listing.dealerListings;
  const propulsionData = getPropulsionData(listing);
  const measurementsData = getMeasurementsData(listing, customUom);
  const featuresData = getFeaturesData(listing);
  const moreDetails = formatMoreDetailsDescriptions(listing.descriptions);
  const website = get(listing, 'contact.website');
  const brokerName = get(listing, 'contact.name');
  const isFSBOSeller = isFSBOContact(listing.contact);
  const isManufacturer = isManufacturerListing(listing.isOemModel);
  const customContact = get(listing, 'customContactInformation');
  const servicesItemsByDFP = get(context, 'services.itemsByDFP', []);
  const salesRep = get(listing, 'salesRep');
  const salesRepPhone = get(salesRep, 'phoneNumbers[0].number');
  const BDPContactFormModal = get(
    context,
    'supports.BDPContactFormModal',
    false
  );
  const brokerSpotlightFeature = get(context, 'pages.details.brokerSpotlight');
  const brokerSpotlightVersion = get(
    context,
    'pages.details.brokerSpotlight.version',
    1
  );
  if (brokerSpotlightFeature && brokerSpotlightVersion === 2) {
    brokerSpotlightInfo = getBrokerSpotlightInfo(
      get(listing, 'owner', null),
      get(listing, 'spotlightDetails', null),
      onOpenContactForm,
      undefined,
      'contact'
    );
  }
  const videos = get(listing, 'videos', []);
  const locale = getCurrentLocale();
  const supportBoatLoansSection = get(
    context,
    `languages.${locale}.supports.bdpBoatLoansSection`,
    false
  );
  const supportsTridentCalculator = get(
    context,
    `languages.${locale}.supports.tridentCalculator`,
    false
  );
  const showCalculator = showPriceCalculation(listing, context);
  const hideTridentFeatures = get(listing, 'owner.hideTridentFeatures', false);
  const boatLoansOpenState =
    openBoatLoansSection !== 'boat-loans' ? 'close' : 'open';
  const supportsConversationalCta = get(
    context,
    'supports.bdp.conversationalCta',
    false
  );

  const newDesignActive = isBrokerBDP(listing, context);

  return (
    <div className="details">
      {newDesignActive && (
        <BoatDetails details={getBoatDetails(listing, customUom)} />
      )}
      {!newDesignActive && (
        <CollapsibleContent initialState="open" classOverride="details">
          <CollapsibleHeader
            id="boat-details"
            onClick={(e, open) => {
              if (open) {
                setCollapseContentTracking('boat-details');
              }
            }}
            priority={3}
          >
            {t(messages.details)}
          </CollapsibleHeader>
          <Collapsible type="no-pad">
            <DataTable
              dataName="details"
              data={getDetailsData(listing, customUom)}
              isLoading={isLoading}
            />
          </Collapsible>
        </CollapsibleContent>
      )}

      <CollapsibleContent initialState="open" classOverride="details">
        <CollapsibleHeader
          id="boat-description"
          onClick={(e, open) => {
            if (open) {
              setCollapseContentTracking('boat-description');
            }
          }}
          priority={3}
        >
          {t(messages.description)}
        </CollapsibleHeader>
        <Collapsible type="no-pad">
          <span>{title}</span>
          <DescriptionBox
            dataName="description"
            showMore={true}
            data={get(listing, 'description', '')}
            isLoading={isLoading}
            tracking={setCollapseContentTracking}
            customContact={customContact}
          />
        </Collapsible>
        <ConversationalCta
          id="description-conversational-cta"
          enabled={supportsConversationalCta}
          variant="button"
          classNames={{ icon: true }}
          icon="description"
          onClick={onOpenContactForm}
          title={t(messages.boatDetails.description.conversationalCta.title)}
          content={t(
            messages.boatDetails.description.conversationalCta.content
          )}
        />
      </CollapsibleContent>
      {salesRep && salesRepPhone && (
        <CollapsibleContent initialState="open" classOverride="details">
          <CollapsibleHeader
            id="contact-information"
            onClick={(e, open) => {
              if (open) {
                setCollapseContentTracking('contact-information');
              }
            }}
            priority={3}
          >
            {t(
              messages.boatDetails.friendlyFeatureName.customContactInformation
            )}
          </CollapsibleHeader>
          <Collapsible type="no-pad">
            {t(messages.contactSalesRep, {
              firstName: get(salesRep, 'firstName'),
              lastName: get(salesRep, 'lastName')
            })}{' '}
            <a href={`tel:${salesRepPhone}`} className="contact-phone">
              {salesRepPhone}
            </a>
          </Collapsible>
        </CollapsibleContent>
      )}

      {supportsTridentCalculator && showCalculator && (
        <PaymentCalculator
          open={paymentCalculatorOpenState}
          counter={openPaymentCounter}
          listing={listing}
          isLoading={isLoading}
          tridentLoanAmount={tridentLoanAmount}
          tridentTeaserRate={tridentTeaserRate}
          tridentTermInMonths={tridentTermInMonths}
          isLeadSubmitted={isLeadSubmitted}
          showModalPreQualified={showModalPreQualified}
          ctaLink={CTA_APPLY_NOW_CALCULATOR_BDP}
          supportsTridentCalculator={supportsTridentCalculator}
        />
      )}

      {supportBoatLoansSection && !hideTridentFeatures && (
        <BoatLoans
          open={boatLoansOpenState}
          counter={openBoatLoansCounter}
          listing={listing}
          isLoading={isLoading}
          editorialContent={boatLoansSection}
          breakpoint={breakpoint}
        />
      )}
      {moreDetails && moreDetails.length > 0 ? (
        <CollapsibleContent initialState="closed" classOverride="details">
          <CollapsibleHeader
            id="more-details"
            onClick={(e, open) => {
              if (open) {
                setCollapseContentTracking('more-details');
              }
            }}
            priority={3}
          >
            {t(messages.moreDetails)}
          </CollapsibleHeader>
          <Collapsible type="no-pad">
            <DescriptionBox
              dataName="more-details"
              showMore={false}
              multiItem={true}
              data={moreDetails}
              isLoading={isLoading}
            />
          </Collapsible>
          <ConversationalCta
            id="more-details-conversational-cta"
            enabled={supportsConversationalCta}
            variant="button"
            classNames={{ icon: true }}
            icon="description"
            onClick={onOpenContactForm}
            title={t(messages.boatDetails.moreDetails.conversationalCta.title)}
            content={t(
              messages.boatDetails.moreDetails.conversationalCta.content
            )}
          />
        </CollapsibleContent>
      ) : null}
      {featuresData.length > 0 ? (
        <CollapsibleContent initialState="closed" classOverride="details">
          <CollapsibleHeader
            id="features"
            onClick={(e, open) => {
              if (open) {
                setCollapseContentTracking('features');
              }
            }}
            priority={3}
          >
            {t(messages.features)}
          </CollapsibleHeader>
          <Collapsible type="no-pad">
            <DataTable
              dataName="features"
              data={featuresData}
              isLoading={isLoading}
            />
          </Collapsible>
          <ConversationalCta
            id="features-conversational-cta"
            enabled={supportsConversationalCta}
            variant="button"
            classNames={{ icon: true }}
            icon="description"
            onClick={(event) =>
              onOpenContactForm(event, false, {
                prePopulatedText: t(
                  messages.boatDetails.features.conversationalCta
                    .prePopulatedText,
                  { portal }
                )
              })
            }
            title={t(messages.boatDetails.features.conversationalCta.title)}
            content={t(messages.boatDetails.features.conversationalCta.content)}
          />
        </CollapsibleContent>
      ) : null}
      {propulsionData.length > 0 ? (
        <CollapsibleContent initialState="closed" classOverride="details">
          <CollapsibleHeader
            id="propulsion"
            onClick={(e, open) => {
              if (open) {
                setCollapseContentTracking('propulsion');
              }
            }}
            priority={4}
          >
            {t(messages.propulsion)}
          </CollapsibleHeader>
          <Collapsible type="no-pad">
            <DataTable
              dataName="propulsion"
              data={propulsionData}
              isLoading={isLoading}
            />
          </Collapsible>
        </CollapsibleContent>
      ) : null}
      <CollapsibleContent initialState="closed" classOverride="details">
        <CollapsibleHeader
          id="measurements"
          onClick={(e, open) => {
            if (open) {
              setCollapseContentTracking('measurements');
            }
          }}
          priority={4}
        >
          {t(messages.measurements)}
        </CollapsibleHeader>
        <Collapsible type="no-pad">
          <DataTable
            dataName="measurements"
            data={measurementsData}
            isLoading={isLoading}
          />
        </Collapsible>
        <ConversationalCta
          id="measurements-conversational-cta"
          enabled={supportsConversationalCta}
          variant="button"
          classNames={{ icon: true }}
          icon="measurements"
          onClick={(event) =>
            onOpenContactForm(event, false, {
              prePopulatedText: t(
                messages.boatDetails.measurements.conversationalCta
                  .prePopulatedText,
                { portal }
              )
            })
          }
          title={t(messages.boatDetails.measurements.conversationalCta.title)}
          content={t(
            messages.boatDetails.measurements.conversationalCta.content
          )}
        />
      </CollapsibleContent>

      {(breakpoint !== BREAKPOINTS.desktop || BDPContactFormModal) &&
        !showManufacturerForm && (
          <ContactGroup
            mode={ContactGroup.MODES.inline}
            breakpoint={breakpoint}
            onOpenContact={onOpenContactForm}
            listing={listing}
            hidden={BDPContactFormModal}
          />
        )}

      {breakpoint !== BREAKPOINTS.desktop && (
        <div className="tablet-ads-wrapper">
          <Ad {...adParams.mobileBox1Params} />
          {breakpoint === BREAKPOINTS.tablet && (
            <Ad {...adParams.mobileBox2Params} />
          )}
        </div>
      )}

      {!isFSBOSeller && dealerListings && dealerListings.length > 0 ? (
        <CollapsibleContent
          initialState="open"
          classOverride="details more-from-dealer-collapsible"
        >
          <CollapsibleHeader
            id="dealerlistings"
            onClick={(e, open) => {
              if (open) {
                setCollapseContentTracking('dealerlistings');
              }
            }}
            priority={3}
          >
            {isManufacturer
              ? t(messages.moreFromManufacturer)
              : t(messages.moreFromDealer, { brokerName })}
          </CollapsibleHeader>
          <Collapsible type="no-pad">
            <DealerOtherProducts
              dealerListings={dealerListings}
              isLoading={props.isWorking}
              listingId={get(listing, 'id')}
              website={website}
              listing={listing}
            />
          </Collapsible>
        </CollapsibleContent>
      ) : null}
      {servicesItemsByDFP && servicesItemsByDFP.length > 0 && (
        <ServicesByDFP
          services={servicesItemsByDFP}
          position={'bottom'}
          adParams={adParams}
        />
      )}

      <ConversationalCta
        id="more-questions-conversational-cta"
        enabled={supportsConversationalCta}
        variant="simple"
        title={t(messages.boatDetails.moreQuestions.conversationalCta.title)}
        link={{
          text: t(
            messages.boatDetails.moreQuestions.conversationalCta.linkText
          ),
          onClick: (event) =>
            onOpenContactForm(event, false, {
              prePopulatedText: t(
                messages.boatDetails.moreQuestions.conversationalCta
                  .prePopulatedText,
                { portal }
              )
            })
        }}
        classNames={{ untruncate: true }}
      >
        {t(messages.boatDetails.moreQuestions.conversationalCta.body.firstRow)}
        <br />
        {t(messages.boatDetails.moreQuestions.conversationalCta.body.secondRow)}
      </ConversationalCta>

      {videos && videos.length > 0 ? (
        <CollapsibleContent initialState="open" classOverride="details">
          <CollapsibleHeader>{t(messages.videoDetails)}</CollapsibleHeader>
          <Collapsible type="no-pad">
            <YoutubeVideos
              videos={videos}
              portal={portal}
              device={breakpoint}
            />
          </Collapsible>
        </CollapsibleContent>
      ) : null}

      {brokerSpotlightFeature &&
        listing.owner &&
        listing.owner.brokerSpotlightId &&
        get(
          listing,
          'spotlightDetails.details.brokerSpotlightConnection',
          null
        ) && (
          <CollapsibleContent initialState="open" classOverride="details">
            <CollapsibleHeader id="brokerSpotlight" priority={4}>
              {t(messages.brokerInformation)}
            </CollapsibleHeader>
            <Collapsible type="no-pad">
              {brokerSpotlightVersion === 2 && brokerSpotlightInfo ? (
                <BrokerSpotlightCard brokerInfo={brokerSpotlightInfo} />
              ) : (
                <BrokerSpotlight owner={listing.owner} />
              )}
            </Collapsible>
          </CollapsibleContent>
        )}
    </div>
  );
};

DetailsSectionVariant1.defaultProps = {
  showManufacturerForm: false
};

DetailsSectionVariant1.propTypes = {
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isLoading: PropTypes.bool,
  isWorking: PropTypes.bool,
  /** Listing information of the boat */
  listing: listingPropTypes.isRequired,
  onOpenContactForm: PropTypes.func,
  setCollapseContentTracking: PropTypes.func.isRequired,
  addLead: PropTypes.func.isRequired,
  adParams: PropTypes.object.isRequired,
  showManufacturerForm: PropTypes.bool,
  customUom: PropTypes.shape({
    length: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    weight: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    speed: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    capacity: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    distance: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    radius: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    })
  }),
  setProductImpression: PropTypes.func.isRequired,
  boatLoansSection: PropTypes.object,
  openBoatLoansSection: PropTypes.string,
  openBoatLoansCounter: PropTypes.number,
  openPaymentSection: PropTypes.string,
  openPaymentCounter: PropTypes.number,
  tridentLoanAmount: PropTypes.number,
  tridentTeaserRate: PropTypes.number,
  tridentTermInMonths: PropTypes.number,
  showModalPreQualified: PropTypes.func,
  supportsTridentCalculator: PropTypes.bool,
  isLeadSubmitted: PropTypes.bool
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      setProductImpression,
      setCollapseContentTracking,
      addLead
    },
    dispatch
  )
)(injectIntl(DetailsSectionVariant1));
